import { Text } from '@mantine/core';

type TaskDescriptionPropsType = {
  description: string;
  isClosed?: boolean;
};

export const TaskDescription: React.FC<TaskDescriptionPropsType> = ({
  description,
  isClosed = false,
}) => {
  return (
    <Text
      mt={2}
      c={isClosed ? 'text.6' : 'text.5'}
      size="xs"
      lh={1.45}
      style={isClosed ? { textDecoration: 'line-through' } : undefined}
    >
      {description}
    </Text>
  );
};
